var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: _vm.mergedClass, style: _vm.mergedStyle },
    _vm._l(_vm.children, function(element, i) {
      return _c(_vm.getComponentName(element.type), {
        key: i,
        ref: "element",
        refInFor: true,
        tag: "Component",
        style: { "flex-grow": _vm.growth[i] },
        attrs: {
          elementPath: _vm.elementPath + "." + i,
          configuration: element
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }